import { render } from "./ShotImage.vue?vue&type=template&id=b9ecc10c&scoped=true"
import script from "./ShotImage.vue?vue&type=script&lang=js"
export * from "./ShotImage.vue?vue&type=script&lang=js"

import "./ShotImage.vue?vue&type=style&index=0&id=b9ecc10c&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9ecc10c"]])

export default __exports__